// extracted by mini-css-extract-plugin
export default {"top":"Rooms_top__bVtnA","name":"Rooms_name__+8NEN","exposition":"Rooms_exposition__3Mp0g"};